import React from 'react'
import { useController } from 'react-hook-form'

function ShopifyFormTextarea({
	name,
	control,
	defaultValue = '',
	onChange,
	inputRef,
	...props
}) {
	const { field } = useController({
		name,
		control,
		defaultValue,
	})

	return (
		<textarea
			{...props}
			name={field.name}
			value={field.value || ''}
			onBlur={field.onBlur}
			onChange={(event) => {
				field.onChange(event.target.value)
				if (onChange)
					onChange(event)
			}}
			ref={(node) => {
				field.ref(node)
				if (typeof inputRef === 'function')
					inputRef(node)
			}}
		/>
	)
}

export default ShopifyFormTextarea